export default __webpack_public_path__ + "static/media/pokerBoard.9c29efa2.png";